var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "C3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      background: "white"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF977C;}\r\n\t.st1{enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4100"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,1.5c0.3,0,0.5,0.2,0.5,0.5v16c0,0.3-0.2,0.5-0.5,0.5H2c-0.3,0-0.5-0.2-0.5-0.5V2c0-0.3,0.2-0.5,0.5-0.5H18  M18,0H2C0.9,0,0,0.9,0,2v16c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V2C20,0.9,19.1,0,18,0L18,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,11.4c-0.1,0.9-0.4,1.6-1,2.2s-1.4,0.8-2.4,0.8c-1.1,0-2-0.4-2.6-1.1s-0.9-1.7-0.9-3V9.7c0-0.8,0.1-1.5,0.4-2.2 s0.7-1.1,1.2-1.4s1.2-0.5,1.9-0.5c1,0,1.8,0.3,2.4,0.8s0.9,1.3,1,2.2H8.3c0-0.6-0.2-1-0.5-1.2S7.2,7.1,6.6,7.1 c-0.6,0-1,0.2-1.3,0.6s-0.4,1.1-0.4,2v0.6c0,0.9,0.1,1.6,0.4,2s0.7,0.6,1.3,0.6c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.5-1.2H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,5.6V7h-0.2c-0.8,0-1.4,0.2-1.8,0.6s-0.7,0.9-0.8,1.6c0.5-0.5,1-0.7,1.7-0.7c0.7,0,1.3,0.3,1.8,0.8s0.7,1.2,0.7,2.1 c0,0.6-0.1,1.1-0.4,1.5s-0.6,0.8-1,1s-0.9,0.4-1.5,0.4c-0.9,0-1.6-0.3-2.2-0.9S11,12,11,10.9v-0.6c0-0.9,0.2-1.7,0.5-2.5 s0.9-1.3,1.5-1.6s1.4-0.6,2.3-0.6H15.6z M14,9.9c-0.3,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.4,0.3-0.5,0.6v0.5c0,0.6,0.1,1,0.3,1.3 S13.6,13,14,13c0.4,0,0.7-0.1,0.9-0.4c0.2-0.3,0.3-0.7,0.3-1.1c0-0.5-0.1-0.8-0.3-1.1C14.7,10.1,14.3,9.9,14,9.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC6);
export default __webpack_public_path__ + "static/media/C6.400120581df495ca3076c12626732d20.svg";
export { ForwardRef as ReactComponent };